import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';
import { handleCancelToS } from '../../actions/tos';
import {
    IConfigContextProps,
    useConfigContext,
} from '../../contexts/ConfigContext';
import {
    IFrontendContext,
    useFrontendContext,
} from '../../contexts/FrontendContext';
import {
    INotificationContext,
    useNotificationsContext,
} from '../../contexts/NotificationsContext';
import { IUserContext, useUserContext } from '../../contexts/UserContext';
import ToSForm from '../forms/ToSForm';
import TakeoverDialog from '../TakeoverDialog';

export interface IToSDialogProps {
    dataTestId?: string;
    cancelActionName: string;
    cancelNotificationMessage: GenericLazyString;
    trackLabel?: string;
    routing?: any;
    handleAcceptToS: () => void;
}

const ToSDialog = ({
    dataTestId = 'tos',
    cancelActionName,
    cancelNotificationMessage,
    trackLabel,
    routing,
    // There are two variants for this: handleAcceptToS and handleAcceptSocialToS
    handleAcceptToS,
}: IToSDialogProps) => {
    const frontendContext: IFrontendContext = useFrontendContext();
    const notificationsContext: INotificationContext = useNotificationsContext();
    const userContext: IUserContext = useUserContext();
    const configContext: IConfigContextProps = useConfigContext();

    const _handleCancelToS = () => {
        handleCancelToS({
            action: cancelActionName,
            notificationMessage: cancelNotificationMessage,
            trackLabel,
            contexts: {
                frontendContext,
                notificationsContext,
                userContext,
                configContext,
            },
            routing,
        });
    };

    return (
        <TakeoverDialog
            onClose={_handleCancelToS}
            isShown={frontendContext.state.showToSDialog}
            containerClasses="eds-l-pad-all-8 eds-align--center"
        >
            <ToSForm
                dataTestId={`${dataTestId}-form`}
                onCancelToS={_handleCancelToS}
                onAcceptToS={handleAcceptToS}
            />
        </TakeoverDialog>
    );
};

export default ToSDialog;
